import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateModule } from '@ngx-translate/core';
import { Location as LocationAngular } from '@angular/common';
import { AppRoutes } from 'src/app/config/routes.config';
@Component({
  selector: 'no-permission',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NoPermissionComponent {
  @Input() content: string;

  readonly AppRoutes = AppRoutes;

  locationUrl = this.location.path().split('/')[1];

  constructor(private location: LocationAngular) {}

  backToHomeModule() {
    localStorage.clear();
    window.location.href = `${environment.ADMIN_APP_URL}/login`;
  }
}
